import type { CSSProperties } from "react";

export interface TextareaProps {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  rows?: number;
  className?: string;
  style?: CSSProperties;
}

export function Textarea({ value, onChange, placeholder, rows = 3, className, style }: TextareaProps) {
  return (
    <textarea
      className={className ? `input textarea ${className}` : "input textarea"}
      style={style}
      rows={rows}
      value={value}
      placeholder={placeholder}
      onChange={(e) => onChange?.(e.target.value)}
    />
  );
}
